import React from "react";
import { Link } from "react-router-dom";
import { TESTIMONIALS } from "@/data/testimonials";

export default function HomeTestimonials() {
  return (
    <section className="section-pad bg-br-paper">
      <div className="container-br">
        <div className="max-w-2xl mb-8">
          <div className="br-eyebrow">What Homeowners Are Saying</div>
          <h2 className="br-headline text-3xl sm:text-4xl mt-3">Client Feedback & Project Experiences</h2>
          <p className="mt-3 text-gray-700">Real homeowner experiences from across Austin and Central Texas.</p>
        </div>
        <div className="grid md:grid-cols-3 gap-5">
          {TESTIMONIALS.slice(0,3).map((t) => (
            <div key={t.id} className="p-6 bg-white border border-gray-200 rounded">
              <p className="text-sm text-gray-700 leading-relaxed">{`"${t.quote}"`}</p>
              <div className="mt-4 text-xs uppercase tracking-widest text-gray-500">{t.name} — {t.location}</div>
              <div className="text-xs text-br-bronze tracking-widest uppercase mt-0.5">{t.project}</div>
            </div>
          ))}
        </div>
        <div className="mt-6"><Link to="/testimonials" className="text-sm uppercase tracking-widest font-bold text-br-bronze hover:underline">View all testimonials →</Link></div>
      </div>
    </section>
  );
}
